<template>
  <div class="v-preemie-in-hospital">
    <sheet>
      <!-- <paragraph :wording="texts" /> -->

      <div class="accordion-wrap">
        <accordion :data="preemieInHospital" />
      </div>

      <to-prev-page routeName="diseases" />
    </sheet>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Accordion from '@/components/Global/Accordion.vue';

import { preemieInHospital } from '@/config/accordion';
// import Paragraph from '@/components/Global/Paragraph.vue';
import ToPrevPage from '@/components/Resources/ToPrevPage.vue';

export default defineComponent({
  name: 'PreemieInHospital',
  components: {
    Accordion,
    // Paragraph,
    ToPrevPage,
  },
  setup() {
    const texts = [
      {
        type: 'large',
        text: '台灣在近十多年來，拜經濟成長之賜，醫療品質有大幅度的進步，早產兒的存活率也提高很多。',
      },
      {
        type: 'normal',
        text: '也因而有愈來愈多早產兒存活下來，和早產有關的種種問題也更加突顯。較易發生在早產兒的問題，諸如：生產窒息、呼吸窘迫症候群、呼吸暫停、血糖過低或過高、電解質不平衡、體溫不穩、易感染、開放性動脈導管、黃疸餵食問題、壞死性腸炎、周腦室及腦室內出血、腦室旁白質軟化、慢性肺疾病及早產兒視網膜病變等。這些問題，會令早產兒的父母覺得很憂心。但實際上，問題的發生及其嚴重性和早產的程度是有很大的關係，也就是說，愈早產的嬰兒發生上述問題的機會愈高。但一個早產兒是否會發生這些問題，是無法在他出生時即能完全預知。因此，在有早產跡象時，母親應到有新生兒加護病房設施的醫院生產;否則，也應在孩子出生後，儘快以救護車及轉運保溫箱，送至上述醫院醫治，使孩子能得到最好的醫療照顧，以預防或治療各種後遺症。',
      },
      {
        type: 'important',
        text: '現就早產兒在出生一週內常見的幾個問題，及在醫院內醫護人員所做的處置，向您一一解說。希望您在這方面有較多及較正確的認識後，可減輕心中的憂慮與擔心。',
      },
    ];

    return {
      preemieInHospital,
      texts,
    };
  },
});
</script>
<style lang="scss" scoped>
.accordion-wrap {
  margin-top: 70px;
}
</style>
